import React from "react";
import Chat from "pages/Home/notification/Chat";

interface ChatPcProps {
  id?: number | string;
  closeDrawer?: () => void;
}

const ChatPc: React.FC<ChatPcProps> = ({ id, closeDrawer }) => {
  return <Chat id={id} closeDrawer={closeDrawer} />;
};

export default ChatPc;
